/* Mobile burger menu reposition */

export function search_bar_reposition() {

	( ( $ ) => {

		let site_navigation_original_position = $( "#site-navigation" ).offset().top + $( "#site-navigation" ).outerHeight();

		// Initial top position
		$( '#search-bar' ).css( 'top', site_navigation_original_position );

		const cov_search_bar_reposition = ( ev ) => {

			const site_topbar_position = ( $( "#site-navigation" ).offset().top + $( "#site-navigation" ).outerHeight() ) - $( window ).scrollTop();

			$( '#search-bar' ).css( 'top', site_topbar_position );
		}

		$( window ).on( 'resize', cov_search_bar_reposition );
		$( window ).on( 'scroll', cov_search_bar_reposition );
		$( '.announcement-bar--top-bar .alert' ).on( 'closed.bs.alert', cov_search_bar_reposition );

		// Focus on the search input when the slide is open
		$( '#search-bar' ).on( 'shown.bs.collapse', ( ev ) => {
			$( ev.currentTarget ).find( '.search-field' ).focus();
		} );

		if ( $( '#community-root-menu-wrapper' ).length > 0 ) {
			$( '#community-root-menu-wrapper' ).on( 'shown.bs.collapse hidden.bs.collapse', ( ev ) => {
				site_navigation_original_position = $( '#community-root-menu' ).outerHeight() || 0 + $( '.announcement-bar--top-bar' ).outerHeight() || 0 - $( '#wpadminbar' ).outerHeight() || 0;
	
				cov_search_bar_reposition( {} );
			} );
		}


	} )( window.jQuery );

}
